import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/message/mutations'
import { path } from '@/store/message/types'
import { mutation } from '@/utils/mutation'
import state, { IMessageState } from '@/store/message/state'

export * from '@/store/message/state'

export const store: Module<IMessageState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
